export default "__VITE_ASSET__CetAqjf4__"